import * as React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { logout } from '../api/authClientApi';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';

export default function LogoutPage(): JSX.Element{

    const history = useHistory();

    useEffect(() => {
        const getData = async () => {
			await logout();
            history.push('/login');
        };
        getData();
    }, []);
    
    return ( 
        <ProtectedPageWrapper requiredPermissions={['Logout']}>
        </ProtectedPageWrapper>
    );
}